import React from 'react';
import { Button, Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ELayout from './ELayout';
import { ArrowLeftCircle } from "react-bootstrap-icons";

const WFHDashboard = () => {
  const navigate = useNavigate();

  return (
    <ELayout heading={
      <div className="mb-3 d-flex align-items-center">
        <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
          <ArrowLeftCircle />
        </Button>
        <span className="ms-3">WFH Management</span>
      </div>
    }>
      <Container className="my-4">
        <Row className="justify-content-center g-4">
          <Col xs={12} md={6}>
            <Card className="shadow text-center">
              <Card.Body>
                <Card.Title>Apply for WFH</Card.Title>
                <Card.Text>Submit your Work From Home request.</Card.Text>
                <Button variant="primary" onClick={() => navigate('/wfh-request')}>
                  Request WFH
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6}>
            <Card className="shadow text-center">
              <Card.Body>
                <Card.Title>View WFH History</Card.Title>
                <Card.Text>See your previous WFH requests and statuses.</Card.Text>
                <Button variant="secondary" onClick={() => navigate('/wfh-history')}>
                  View History
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </ELayout>
  );
};

export default WFHDashboard;
